import React from 'react';
import Hero from '../Hero';
import RecentSearches from '../RecentSearches';
import WhyBookWithUs from '../WhyBookWithUs';
import './styles.scss';

const ActivityHome: React.FC = () => {
  return (
    <div className="home">
      <Hero />
      <div className="home__content">
        <RecentSearches />
        <WhyBookWithUs />
      </div>
    </div>
  );
};

export default ActivityHome;
